import React from "react";
import { Link } from "react-router-dom";
import defaultLogo from "../../Mycomponent/Assets/seoimg/logo.png";
import "../../Mycomponent/css/header.css";
import { stringToBoolean } from "../../helperJs/helper";

const Header = ({ showLogo, logo }) => {
  const showLogoStatus = stringToBoolean(showLogo);
  return (
    <>
      <header className="navBar header-container">
        <div className="d-flex w-100 h-100 container">
          {!showLogoStatus ? null : logo === "NO LOGO" ? null : (
            <>
              <img
                src={logo === "rankspro.io" ? defaultLogo : logo}
                alt="RanksPro.io"
                className="header-logo"
              />
              {logo === "rankspro.io" && (
                <Link to={"/register"}>
                  <button className="header-btn btn_new_bg">
                    Start a Free Trial
                  </button>
                </Link>
              )}
            </>
          )}
        </div>
      </header>
    </>
  );
};

export default Header;
